import router from '../../router';
import auth from '../../services/auth';
import ApiService from '../../services/api.service';
import jwt from 'jwt-decode';
import { ERROR_HANDLE_ERROR } from '../error/actions.type';
import { DETERMINE_MENU_ITEMS } from '../nav/nav.actions';

import {
    SET_PROFILE,
    SET_ACCESS_TOKEN,
    SET_ID_TOKEN,
    SET_VERIFICATION,
    SET_AUTHENTICATED,
    SET_GROUPS,
    SET_COGNITO_IDENTITY_ID,
    SET_COGNITO_IDENTITY_ROLE,
    CLEAR_COGNITO_IDENTITY_ROLES
} from './auth.mutations';

import { SIGNOUT, AUTHENTICATE, HANDLE_SESSION_EXPIRED } from './auth.actions';

import { SET_RTPS_SEARCH_COMPLETE } from '../rtps/rtps.mutations';

import { SET_PA_SEARCH_COMPLETE } from '../pa/mutations.type';

export default {
    state: {
        profile: null,
        accessToken: null,
        verification: null,
        isAuthenticated: false,
        cognitoIdentity: {},
        cognitoRoles: []
    },

    getters: {
        profile: state => state.profile,
        expiration: state => state.profile ? state.profile.exp : null,
        verification: state => () => state.verification,
        idToken: state => () => state.idToken,
        accessToken: state => state.idToken,
        isAuthenticated: state => state.isAuthenticated,
        groups: state => state.groups,
        cognitoIdentity: state => state.cognitoIdentity,
        cognitoRoles: state => state.profile ? state.profile["cognito:roles"] : null
    },

    mutations: {
        [SET_PROFILE]: (state, profile) => {
            state.profile = profile;
        },
        [SET_ACCESS_TOKEN]: (state, accessToken) => {
            state.accessToken = accessToken;
        },
        [SET_ID_TOKEN]: (state, idToken) => {
            state.idToken = idToken;
        },
        [SET_VERIFICATION]: (state, verification) => {
            state.verification = verification;
        },
        [SET_AUTHENTICATED]: (state, isAuthenticated) => {
            state.isAuthenticated = isAuthenticated;
        },
        [SET_GROUPS]: (state, groups) => {
            state.groups = groups;
        },
        [SET_COGNITO_IDENTITY_ID]: (state, identityId) => {
            state.cognitoIdentity.identityId = identityId;
        },
        [SET_COGNITO_IDENTITY_ROLE]: (state, role) => {
            if (role) {
                state.cognitoIdentity.roles[role.name] = role.value;
            }
        },
        [CLEAR_COGNITO_IDENTITY_ROLES]: (state) => {
            state.cognitoIdentity.roles = {};
        },
        [SET_RTPS_SEARCH_COMPLETE]: (state, results) => {
          state.searchResults = results;
        },
        [SET_PA_SEARCH_COMPLETE]: (state, results) => {
          state.searchResults = results;
        }
    },

    actions: {
        [SIGNOUT]: function (context, payload) {
            context.commit(SET_PROFILE, null);
            context.commit(SET_ACCESS_TOKEN, null);
            context.commit(SET_ID_TOKEN, null);
            context.commit(SET_AUTHENTICATED, false);
            context.commit(SET_GROUPS, null);
            context.commit(CLEAR_COGNITO_IDENTITY_ROLES, null);
            context.commit(SET_COGNITO_IDENTITY_ID, null);
            context.commit(SET_PROFILE, null);
            context.commit(SET_RTPS_SEARCH_COMPLETE, null);
            context.commit(SET_PA_SEARCH_COMPLETE, null);
            context.dispatch(DETERMINE_MENU_ITEMS);
        },
        [AUTHENTICATE]: function (context, payload) {
            if (payload.verification === null || payload.verification !== context.getters.verification()) {
                router.push({ name: 'error', params: { message: 'The verification state in the authentication response did not match our original request' } });
                return;
            }

            if (payload.idToken === null || (jwt(payload.idToken).token_use || null) !== 'id') {
                router.push({ name: 'error', params: { message: 'The authentication response did not include a valid ID token' } });
                return;
            }
            const profile = jwt(payload.idToken);
            context.commit(SET_PROFILE, profile);
            context.commit(SET_ACCESS_TOKEN, payload.accessToken);
            context.commit(SET_ID_TOKEN, payload.idToken);
            context.commit(SET_AUTHENTICATED, true);
            context.commit(SET_GROUPS, profile["cognito:groups"]);
            context.commit(CLEAR_COGNITO_IDENTITY_ROLES, null);
            context.commit(SET_COGNITO_IDENTITY_ID, null);
            ApiService.setHeader(payload.idToken);
            context.dispatch(DETERMINE_MENU_ITEMS);
            router.push({ name: 'rtps-portal' });
        },
        [HANDLE_SESSION_EXPIRED]: function (context, err) {
            context.dispatch(ERROR_HANDLE_ERROR, { message: "Session expired" });
            context.dispatch(SIGNOUT);
            setTimeout(() => {
                auth.authenticate();
            }, 3000);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/auth/auth.module.js